import { classNames } from "primereact/utils";
import { IconButton } from "../button/iconButton/IconButton";
import { IconType } from "../../icons/Icon";
import { RenderWhen } from "../../infrastructure/components/RenderWhen";
import styles from "./FilterIconButton.module.scss";

interface IFilterIconButtonProps {
  onClick: () => void;
  /** Number shown in the red badge; no badge when 0. */
  activeFiltersCount?: number;
  iconSize?: string;
  className?: string;
  ariaLabel?: string;
}

/**
 * Filter trigger used in page headers - opens the FiltersSidePanel and shows
 * how many filters are currently active.
 */
export const FilterIconButton = ({
  onClick,
  activeFiltersCount = 0,
  iconSize = "25px",
  className,
  ariaLabel = "Филтри",
}: IFilterIconButtonProps) => {
  const hasActiveFilters = activeFiltersCount > 0;

  return (
    <div className={classNames(styles.root, className)}>
      <IconButton
        iconType={IconType.Filters}
        iconHeight={iconSize}
        iconWidth={iconSize}
        onClick={onClick}
        ariaLabel={ariaLabel}
        className={hasActiveFilters ? styles.root_active : ""}
      />

      <RenderWhen condition={hasActiveFilters}>
        <span className={styles.root_badge}>{activeFiltersCount}</span>
      </RenderWhen>
    </div>
  );
};
